import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import './style.scss';
import { setActiveTabForSameAsset } from './helpers';
import { GeneralTabContent } from './GeneralTabContent';
import { LoadingIndicator } from 'sharedComponents/PowertrainLoadingIndicator';

const GeneralTabsScrollable = ({ options, defaultTab, handleSelectedTab, activeTab, parentElementId, variant = 'primary', ...props }) => {
	const [selectedTabKey, setSelectedTabKey] = useState(setActiveTabForSameAsset(options, activeTab, defaultTab));
	const handleTabSelection = ({ target: { id } }) => {
		// Check if handleSelectedTab returns false to prevent tab change
		let shouldChangeTab = true;
		if (handleSelectedTab) {
			const result = handleSelectedTab(id);
			if (result === false) {
				shouldChangeTab = false;
			}
		}

		// Only update internal state if tab change is allowed
		if (shouldChangeTab) {
			setSelectedTabKey(id);
		}
	};

	useEffect(() => {
		options[selectedTabKey]?.hidden && setSelectedTabKey(defaultTab);
	}, [options]);

	// Sync internal selectedTabKey with external activeTab prop
	useEffect(() => {
		if (activeTab && activeTab !== selectedTabKey) {
			setSelectedTabKey(activeTab);
		}
	}, [activeTab]);

	return (
		<GeneralTabContent handleTabSelection={handleTabSelection} activatedTabKey={selectedTabKey} options={options} variant={variant} parentElementId={parentElementId} {...props}>
			<React.Suspense fallback={<LoadingIndicator />}>
				<React.Fragment key={selectedTabKey}>
					{options[selectedTabKey]?.component}
				</React.Fragment>
			</React.Suspense>
		</GeneralTabContent>
	);
};

GeneralTabsScrollable.propTypes = {
	defaultTab: PropTypes.any,
	options: PropTypes.oneOfType([
		PropTypes.objectOf(PropTypes.shape({
			title: PropTypes.string,
			disabled: PropTypes.oneOf([PropTypes.bool, PropTypes.any]),
			hidden: PropTypes.oneOf([PropTypes.bool, PropTypes.any]),
			component: PropTypes.oneOf([PropTypes.node, PropTypes.any]),
		})),
		PropTypes.any]),
	variant: PropTypes.oneOf(['primary', 'secondary', 'panel']),
	controlledWithRoutes: PropTypes.bool,
	parentElementId: PropTypes.string,
};

export default GeneralTabsScrollable;
